import toaster from 'react-hot-toast';

import { CloseIcon, InfoCircleIcon } from '@/assets/icons';
import { mergeClasses } from '@/utils';

import { ICustomInfoToast } from './Alert.interfaces';
import styles from './Alert.module.css';

const ToastInfo: React.FC<ICustomInfoToast> = ({ message, t }: ICustomInfoToast) => {
  return (
    <div
      className={mergeClasses(
        // Base classes
        'font-semibold text-sm max-w-[550px] flex items-center bg-semantic-info-base rounded-soft p-base text-white',
        // State-based classes
        t.visible ? styles['animate-enter'] : styles['animate-leave'],
      )}
    >
      <div className="mr-s-plus">
        <InfoCircleIcon />
      </div>
      <div className="mr-m break-normal">{message}</div>
      <button onClick={() => toaster.dismiss(t.id)}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default ToastInfo;
